import template from './einzelticket.html';
import controller from './einzelticket.controller';
import './einzelticket.scss';

let einzelticketComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default einzelticketComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/einzelticket/einzelticket.component.js